













































































import Vue from 'vue';
import { Type, EntityIndex, objectToArray, Entity } from 'expangine-runtime';
import { editTypeIndexTypes } from './EditEntityIndex';
import { getConfirmation } from './Confirm';
import { Preferences, PreferenceCategory } from './Preference';
import { Registry } from '../runtime/Registry';


const PREF_REMOVE_TYPE_INDEX = Preferences.define({
  key: 'remove_type_index',
  label: 'Remove user-defined type indexes without confirmation',
  category: [PreferenceCategory.CONFIRM],
  defaultValue: false,
});

export default Vue.extend({
  props: {
    entity: {
      type: Object as () => Entity,
      required: true,
    },
    index: {
      type: Object as () => EntityIndex,
      required: true,
    },
    registry: {
      type: Object as () => Registry,
      required: true,
    },
    propsOnly: {
      type: Boolean,
      default: false,
    },
    propTypesAllowed: {
      type: Object as () => Type,
      default: () => editTypeIndexTypes,
    },
    hideName: {
      type: Boolean,
      default: false,
    },
  },
  computed: {    
    props(): Array<{ text: string, value: string }> {
      return objectToArray(this.entity.type.options.props, (type, name) => [name, type] as [string, Type])
        .filter(([name, type]) => this.propTypesAllowed.acceptsType(type))
        .map(([value, type]) => ({  value, text: value + ': ' + this.getTypeDescription(type) }))
      ;
    },
    propsAvailable(): Array<{ text: string, value: string }> {
      return this.props.filter(({ value }) => this.index.props.indexOf(value) === -1);
    },
  },
  methods: {
    renamed(newName: string) {
      const { entity, index } = this;
      const oldName = index.name;

      index.name = newName;
      Vue.delete(entity.indexes, oldName);
      Vue.set(entity.indexes, newName, index);

      this.$emit('renamed', index);
    },
    async remove() {
      const { entity, index } = this;

      if (await getConfirmation({ pref: PREF_REMOVE_TYPE_INDEX })) {
        Vue.delete(entity.indexes, index.name);

        this.$emit('removed');
      }
    },
    getTypeDescription(type: Type) {
      return this.registry.getTypeDescribe(type);
    },
    getPropType(prop: string) {
      return prop in this.entity.type.options.props
        ? this.getTypeDescription(this.entity.type.options.props[prop])
        : '';
    },
    addProp(prop: string) {
      this.index.props.push(prop);
      this.save();
    },
    moveProp(index: number, dir: number) {
      const props = this.index.props;
      const next = index + dir;
      if (index >= 0 && index < props.length) {
        const moving = props[index];
        props.splice(index, 1);
        props.splice(next, 0, moving);
      }
      this.save();
    },
    async removeProp(index: number) {
      this.index.props.splice(index, 1);
      this.save();
    },
    save() {
      const { entity, index } = this;

      Vue.set(entity.indexes, index.name, index);

      this.$emit('saved', index);
    },
    validateName(name: string) {
      if (!name) {
        return 'A name is required.';
      }

      const existing = this.entity.indexes[name];
      if (existing && existing !== this.index) {
        return 'An index already exists with that name.';
      }

      return '';
    },
  },
});
